import React from "react";

import SinglePagePDFViewer from "./single-page";
import AllPagesPDFViewer from "./all-page";

/* This is required only if the project file is located 
inside the app. Otherwise you can use the external link of the pdf file*/
import samplePDF from "./Resume.pdf";

export default function App() {
  return (
    <div
      className="App"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "90%",
        flexDirection: "column",
      }}
    >
      <hr />
      <SinglePagePDFViewer pdf={samplePDF} pages={[1, 2]} />
    </div>
  );
}
